import { openDB } from 'idb';

async function getDB() {
  const db = await openDB('AvatarDB', 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains('avatars')) {
        db.createObjectStore('avatars');
      }
    },
  });
  return db;
}

export async function cacheImage(key, value) {
  const db = await getDB();
  const tx = db.transaction('avatars', 'readwrite');
  tx.objectStore('avatars').put(value, key);
  await tx.complete;
}

export async function getCachedImage(key) {
  const db = await getDB();
  return await db.transaction('avatars').objectStore('avatars').get(key);
}

export async function clearAvatarCache() {
  const db = await getDB();
  const tx = db.transaction('avatars', 'readwrite');
  const store = tx.objectStore('avatars');
  await store.clear();
  await tx.complete;
}

export const indexedDbConfig = {
  name: 'userAvatarDB',
  version: 1,
  stores: [
    {
      name: 'images',
      keyPath: 'key',
      autoIncrement: false,
      indexes: [{ name: 'by_key', keyPath: 'key', options: { unique: true } }],
    },
  ],
};
